<template>
  <div class="fixed-toast-container">
    <div class="add bg-fff">
      <header class="fx-sb">
        <div class="title col-000 fw-600 f24">添加书签</div>
        <i
          class="iconfont icon-exit f32 col-red"
          @click="exit()"></i>
      </header>
      <main>
        <el-form
          :model="data"
          status-icon
          :rules="rules"
          label-suffix="："
          ref="form"
          label-width="100px">
          <el-form-item
            label="书签名称"
            prop="name">
            <el-input
              @keyup.enter.native="submitForm('form')"
              placeholder="请输入书签名称"
              v-model="data.name"></el-input>
          </el-form-item>
          <el-form-item
            label="链接"
            prop="url">
            <el-input
              @keyup.enter.native="submitForm('form')"
              placeholder="请输入书签链接"
              v-model="data.url"></el-input>
          </el-form-item>
          <el-form-item
            label="一级分类"
            prop="category">
            <el-autocomplete
              class="inline-input"
              v-model="data.category"
              :fetch-suggestions="querySearch_"
              placeholder="请输入书签类型"></el-autocomplete>
          </el-form-item>
          <el-form-item
            label="二级分类"
            prop="type">
            <el-autocomplete
              class="inline-input"
              v-model="data.type"
              :fetch-suggestions="querySearch"
              placeholder="请输入书签类型"></el-autocomplete>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="comment">
            <el-input
              type="textarea"
              :autosize="{ maxRows: 5 }"
              resize="none"
              v-model="data.comment"
              placeholder="请输入书签备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="warning"
              @click="exit()"
              >取消</el-button
            >
            <el-button
              type="primary"
              @click="submitForm('form')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </main>
    </div>
  </div>
</template>

<script>
import { throttle } from "@/assets/Utils/index";
export default {
  data() {
    return {
      data: {
        name: "", // 书签名称
        url: "", // 书签链接
        category: "", // 书签一级分类
        type: "", // 书签二级分类
        comment: "", // 书签备注
      },
      group: [], // 书签分组数据
      category: [], // 书签一级类目
      rules: {
        name: [
          {
            type: "string",
            whitespace: true,
            required: true,
            message: "请输入书签名称!",
            trigger: "blur",
          },
        ],
        url: [
          {
            type: "url",
            required: true,
            message: "请输入正确的网络地址!",
            trigger: "blur",
          },
        ],
        category: [
          {
            type: "string",
            whitespace: true,
            required: true,
            message: "请输入一级分类!",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.axios
      .get("/bookmark/group")
      .then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.group = data;
          this.category = Object.keys(data).map(item => {
            return { value: item };
          });
        } else {
          this.group = {};
          this.category = [];
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    querySearch(queryString, cb) {
      let group = this.data.category.length ? this.group[this.data.category] : [];
      group = group ? group : [];
      var results = queryString
        ? group.filter(item => {
            return item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
          })
        : group;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearch_(queryString, cb) {
      let { category } = this;
      let results = queryString
        ? category.filter(item => {
            return item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
          })
        : category;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    submitForm: throttle(function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = this.data;
          for (let key in this.data) {
            data[key] = data[key].trim();
          }
          this.axios
            .post("/bookmark/add", { data })
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$parent.addData = false;
                this.$parent.getData();
                this.$parent.choose();
              } else if (res.data.code === 201) {
                this.$parent.addData = false;
                this.$message.error(`已存在此链接,名为: ${res.data.name}`);
              } else {
                console.log(res);
                this.$message.error("添加失败");
              }
            })
            .catch(err => {
              this.$message.error("添加失败");
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }),
    exit() {
      this.$emit("update:data", null);
    },
    exit() {
      this.$parent.addData = false;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .add {
    width: 600px;
    border-radius: 20px;
    padding: 20px;
    > header {
      padding-bottom: 20px;
    }
    > main {
      width: 500px;
      ::v-deep(.el-form) {
        label {
          font-size: 15px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .add {
    width: 94.6667vw;
    border-radius: 2.6667vw;
    padding: 2.6667vw;
    > header {
      padding-bottom: 2.6667vw;
    }
    > main {
      width: 89.3333vw;
      ::v-deep(.el-form) {
        label {
          font-size: 2vw;
        }
      }
    }
  }
}
.add {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  > header {
    width: 100%;
  }
  > main {
    ::v-deep(.el-form) {
      label {
        font-weight: 600;
        color: #333;
      }
      .el-autocomplete {
        width: 100%;
      }
      > .el-form-item:last-child {
        margin: 0;
        > .el-form-item__content {
          display: flex;
          flex-flow: row nowrap !important;
          justify-content: space-between !important;
          .el-button {
            margin: 0;
          }
          &::after,
          &::before {
            display: none;
          }
        }
      }
    }
  }
}
</style>
